/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Checkemaildesc2Inputs */

const zh_auth_checkemaildesc2 = /** @type {(inputs: Auth_Checkemaildesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们已向您的邮箱发送了密码重置链接，请查收并按照指引操作。`)
};

const en_auth_checkemaildesc2 = /** @type {(inputs: Auth_Checkemaildesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We've sent a password reset link to your email address. Please check your inbox and follow the instructions.`)
};

const es_auth_checkemaildesc2 = /** @type {(inputs: Auth_Checkemaildesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos enviado un enlace de restablecimiento a tu correo electrónico. Revisa tu bandeja de entrada y sigue las instrucciones.`)
};

/**
* | output |
* | --- |
* | "We've sent a password reset link to your email address. Please check your inbox and follow the instructions." |
*
* @param {Auth_Checkemaildesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_checkemaildesc2 = /** @type {((inputs?: Auth_Checkemaildesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Checkemaildesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_checkemaildesc2(inputs)
	if (locale === "en") return en_auth_checkemaildesc2(inputs)
	return es_auth_checkemaildesc2(inputs)
});
export { auth_checkemaildesc2 as "auth_checkEmailDesc" }